export default __webpack_public_path__ + "static/media/skippedmeal@2x.984b8813.jpg";